module.exports = __webpack_public_path__ + "static/key-turok-89b6977e96f6e1af8c16769ea4a34ad0.webp";